import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveEmphasis16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMoveEmphasis16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M13.587 2.209a.6.6 0 0 1-.6.6H3.025a.6.6 0 1 1 0-1.2h9.962a.6.6 0 0 1 .6.6m0 11.57a.6.6 0 0 1-.6.6H3.025a.6.6 0 1 1 0-1.2h9.962a.6.6 0 0 1 .6.6m-1.892-5.593A3.7 3.7 0 0 1 8.19 11.69l-.19.005a3.7 3.7 0 0 1-3.695-3.51l-.005-.19A3.7 3.7 0 0 1 7.809 4.3l.19-.005a3.7 3.7 0 0 1 3.701 3.7zm-1.195-.19a2.501 2.501 0 1 0-5.003 0 2.501 2.501 0 0 0 5.003 0"
            />
        </svg>
    );
}
export default memo(IconMoveEmphasis16);
